export { initSplide } from "./splide-service.js";
export { SPLIDE_TYPES } from "./splide-types.js";
